import React from "react";
import {Col} from "reactstrap";
import {ViewConfig} from "../views/ViewConfig";


export default class MainPanelComponent extends React.Component {
  render() {
    return <Col
      xs={ViewConfig.MAIN_PANEL.xs}
      sm={ViewConfig.MAIN_PANEL.sm}
      md={ViewConfig.MAIN_PANEL.md}
      lg={ViewConfig.MAIN_PANEL.lg}
      xl={ViewConfig.MAIN_PANEL.xl}
      className={"main-panel"}
      {...this.props}
    >
      {this.props.children}
    </Col>
  }
}
